import React from 'react';
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  IconButton,
  Portal,
  Spinner,
} from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { Ellipsis, Download } from 'lucide-react';
import { FiMoreHorizontal } from 'react-icons/fi/index.js';

interface AssessmentActionsMenuProps {
  variant?: 'table' | 'header';
  stopPropagation?: boolean;
  isDownloading?: boolean;
  onDownloadReport: () => void;
}

export function AssessmentActionsMenu({
  variant = 'header',
  stopPropagation = false,
  isDownloading = false,
  onDownloadReport,
}: AssessmentActionsMenuProps): React.ReactElement {
  const handleClick = (callback: () => void) => (e: React.MouseEvent) => {
    if (stopPropagation) {
      e.stopPropagation();
    }
    callback();
  };

  const MenuWrapper = variant === 'table' ? Portal : React.Fragment;

  return (
    <Menu>
      <MenuButton
        as={IconButton}
        aria-label="Options"
        icon={
          isDownloading ? (
            <Spinner size="xs" />
          ) : variant === 'table' ? (
            <Ellipsis width="20px" height="20px" />
          ) : (
            <FiMoreHorizontal />
          )
        }
        variant="ghost"
        size={variant === 'table' ? 'sm' : undefined}
        onClick={stopPropagation ? (e) => e.stopPropagation() : undefined}
        display={variant === 'table' ? 'inline-flex' : undefined}
        isDisabled={isDownloading}
      />
      <MenuWrapper>
        <MenuList>
          <MenuItem
            icon={<Download size={16} />}
            onClick={handleClick(onDownloadReport)}
            isDisabled={isDownloading}
          >
            <Trans>Download report</Trans>
          </MenuItem>
        </MenuList>
      </MenuWrapper>
    </Menu>
  );
}
